import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheFutureOfItSupport from "./sections/TheFutureOfItSupport";
import TheEfficiencyGap from "./sections/TheEfficiencyGap";
import OurDigitalWorkforce from "./sections/OurDigitalWorkforce";
import TheIntegrationRoadmap from "./sections/TheIntegrationRoadmap";
import TrustedByInnovators from "./sections/TrustedByInnovators";
import VoicesOfEfficiency from "./sections/VoicesOfEfficiency";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheFutureOfItSupport />
      <TheEfficiencyGap />
      <OurDigitalWorkforce />
      <TheIntegrationRoadmap />
      <TrustedByInnovators />
      <VoicesOfEfficiency />
      <Footer />
    </div>;
}